import { FC } from "react";
import { Notification } from "@mantine/core";

type Props = {
  isIndividual?: boolean;
};

const BankAccNameDisclaimer: FC<Props> = ({ isIndividual = false }) => {
  return (
    <Notification
      withCloseButton={false}
      color="teal"
      style={{ marginBottom: "20px", marginTop: "20px" }}
      title="Account Holder Name"
    >
      {isIndividual
        ? "Please ensure that the account holder name matches your name registered on our platform (first name followed by last name)."
        : "Please ensure that the account holder name matches the company name registered on our platform."}
    </Notification>
  );
};

export default BankAccNameDisclaimer;
